var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_5142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.805 2.69556C17.68 2.57058 17.5105 2.50037 17.3337 2.50037C17.1569 2.50037 16.9874 2.57058 16.8623 2.69556L10.0003 9.55756L3.13835 2.69556C3.01333 2.57058 2.84379 2.50037 2.66701 2.50037C2.49024 2.50037 2.3207 2.57058 2.19568 2.69556C2.0707 2.82058 2.00049 2.99011 2.00049 3.16689C2.00049 3.34367 2.0707 3.51321 2.19568 3.63822L9.05768 10.5002L2.19568 17.3622C2.0707 17.4872 2.00049 17.6568 2.00049 17.8336C2.00049 18.0103 2.0707 18.1799 2.19568 18.3049C2.3207 18.4299 2.49024 18.5001 2.66701 18.5001C2.84379 18.5001 3.01333 18.4299 3.13835 18.3049L10.0003 11.4429L16.8623 18.3049C16.9874 18.4299 17.1569 18.5001 17.3337 18.5001C17.5105 18.5001 17.68 18.4299 17.805 18.3049C17.93 18.1799 18.0002 18.0103 18.0002 17.8336C18.0002 17.6568 17.93 17.4872 17.805 17.3622L10.943 10.5002L17.805 3.63822C17.93 3.51321 18.0002 3.34367 18.0002 3.16689C18.0002 2.99011 17.93 2.82058 17.805 2.69556Z",
    fill: "#858D9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_5142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitCross);
export default __webpack_public_path__ + "static/media/exitCross.1d39feba662ebe5cccecd43723e74578.svg";
export { ForwardRef as ReactComponent };